import React from "react";
import { useRADSelection } from "../../RADHandler/contexts/RADSelectionContext.jsx";
import { CSButton, ButtonGroup, Toggle } from "@cadenza/ui";
import { ConnectionIcon, ConnectionRemoveIcon } from "@cadenza/icons";
import { FaRegEyeSlash, FaRegEye } from "react-icons/fa";

const InteractionEditor = ({ editComponent, onAction }) => {
  const { isConnecting, showTargets, setShowTargets } = useRADSelection();
  if (!editComponent) return null;

  const segmentOption =
    editComponent.class === "connection" &&
    editComponent.interactions.length > 2;

  return (
    <>
      <h3>{`Interaction Manager`}</h3>
      {segmentOption && (
        <span className="info-text">
          This connection has multiple segments.
        </span>
      )}
      <ButtonGroup align="between" spacing="compact">
        <CSButton
          className="btn-nowrap-ellipsis"
          onClick={() => {
            onAction({
              action: "startConnecting",
              editComponent,
            });
          }}
          title="Add interaction"
          aria-label="Add an interaction"
        >
          <ConnectionIcon className="button-icon" width={30} /> Connect
        </CSButton>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <label
            htmlFor="show-targets-toggle"
            style={{ fontSize: "14px", color: "var(--text-secondary)" }}
          >
            Targets:
          </label>
          <Toggle
            id="show-targets-toggle"
            isOn={showTargets}
            onToggle={setShowTargets}
            onIcon={
              <FaRegEye
                className="cs-icon"
                style={{ color: "var(--text-secondary)" }}
              />
            }
            offIcon={
              <FaRegEyeSlash
                className="cs-icon"
                style={{ color: "var(--text-secondary)" }}
              />
            }
            onLabel="Hide targets"
            offLabel="Show targets"
            ariaLabel="Toggle target visibility"
            size="small"
          />
        </div>
      </ButtonGroup>
      {isConnecting && (
        <span className="info-text">
          Select an interaction or state to connect to...
        </span>
      )}
      {!["role", "state", "case", "part", "repeat"].includes(
        editComponent.class
      ) &&
        !isConnecting && (
          <CSButton
            className="btn-nowrap-ellipsis"
            onClick={() => {
              onAction({
                action: "removeInteraction",
                editComponent,
              });
            }}
            title="Remove this interaction"
            aria-label="Remove this section of the interaction"
          >
            <ConnectionRemoveIcon className="button-icon" width={30} /> Remove
            this interaction
          </CSButton>
        )}
    </>
  );
};

export default InteractionEditor;
